module.exports = __webpack_public_path__ + "static/media/education.9abd4efa.svg";